module.exports = __webpack_public_path__ + "img/delete.dc3669ad.svg";